module.exports = __webpack_public_path__ + "static/media/warning-red.02db797d.svg";